var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('read-more',{attrs:{"targetId":_vm.oneId + '_' + _vm.itemType,"text":_vm.item,"addMore":this.detailView,"showMore":this.propShowMore,"contentHeight":this.propContentHeight},on:{"update-show-more":_vm.updateShowMore,"update-content-height":_vm.updateContentHeight}},[_vm._v("\n    "+_vm._s(_vm.item)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59349dd6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/One/OneItem.vue
// module id = 952
// module chunks = 1